
//正式环境
const activityId = "sid-443DC293-7419-49EC-B9B1-D63BFFF50A33"
const userinfo = {"username": "安吉王晨",
}
const BASE_URL = 'https://zd.zrzyt.zj.gov.cn'
const pro = '/processCenter'
const infoAxios = 'https://ygzq.zrzyt.zj.gov.cn:21099'
const xmxxk2form = 'https://zd.zrzyt.zj.gov.cn'//线上



//测试环境
// const activityId = "sid-40cfed36-d804-11ec-b388-b626d4f70881"
// const userinfo = {
//     "username": "普陀区",
// }
// const BASE_URL = 'http://192.168.9.8'; 
// const pro = ':19013';
// const infoAxios = 'http://192.168.9.8:19013';
// const xmxxk2form = 'http://192.168.9.8:21099';

// const xmxxk2form = '/api'//本地测试

export default {
    activityId,userinfo,BASE_URL,pro,infoAxios,xmxxk2form
}



//////////////////
// WEBPACK FOOTER
// ./public/static/config.js
// module id = xpbV
// module chunks = 20